module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26.5 14a.5.5 0 01.5.5V20a6 6 0 01-6 6H11a6 6 0 01-6-6v-5.5a.5.5 0 01.5-.5zM25 16H7v4a4 4 0 004 4h10a4 4 0 004-4zm.366-9.263a1 1 0 01.366 1.366L22.904 13h-2.309L24 7.103a1 1 0 011.366-.366zM7.75 9.333L7.2 8.6a1 1 0 111.6-1.2l1 1.333a1 1 0 010 1.2l-.55.734.55.733a1 1 0 01-1.6 1.2l-1-1.333a1 1 0 010-1.2zm4-1L11.2 7.6a1 1 0 011.6-1.2l1 1.333a1 1 0 010 1.2l-.55.734.55.733a1 1 0 01-1.6 1.2l-1-1.333a1 1 0 010-1.2z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-recipes.svg
// module id = 704
// module chunks = 0